import type { FC } from 'react'
import React from 'react'
import styled from 'styled-components'

import { Colours } from '@/utils/styles'

export type PillType = 'positive' | 'neutral' | 'negative' | 'caution' | 'info'

export type Props = {
  type: PillType
}

const BasePill = styled.div`
  padding: 5px 10px;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  display: inline-block;
  height: fit-content;
  width: fit-content;
`

const NeutralPill = styled(BasePill)`
  background-color: ${Colours.darkGrey};
`

const CautionPill = styled(BasePill)`
  background-color: ${Colours.orange};
`

const PositivePill = styled(BasePill)`
  background-color: ${Colours.teal};
`

const NegativePill = styled(BasePill)`
  background-color: ${Colours.red};
`

const InfoPill = styled(BasePill)`
  background-color: ${Colours.blue};
`

const Pill: FC<Props> = ({ type, children }) => {
  switch (type) {
    case 'positive':
      return <PositivePill>{children}</PositivePill>
    case 'negative':
      return <NegativePill>{children}</NegativePill>
    case 'caution':
      return <CautionPill>{children}</CautionPill>
    case 'info':
      return <InfoPill>{children}</InfoPill>
    default:
      return <NeutralPill>{children}</NeutralPill>
  }
}

export default Pill
